import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRED, URL } = validators;
    const errors = {};

    // eslint-disable-next-line no-console
    console.log('values', values);

    if (REQUIRED(values.purpose)) {
        errors.purpose = 'Please enter the purpose (Max 200 chars).';
    }
    if (values.purpose && values.purpose?.length > 200) {
        errors.purpose = 'Cannot be more than 200 characters.';
    }
    if (REQUIRED(values.amountType)) {
        errors.amountType = 'Please select amount type.';
    }
    if (REQUIRED(values.amount)) {         
        errors.amount = 'Please enter amount.';     
    } else if (values.amount === '0' || values.amount === 0) {             
        errors.amount = 'Please enter an amount greater than zero.';         
    } else if (!/^\d+(\.\d{1,2})?$/.test(values.amount)) {  
        errors.amount = 'Only up to two decimal places are allowed.';  
    }
    
    if (REQUIRED(values.minAmount)) {         
        errors.minAmount = 'Please enter minimum amount.';     
    } else if (values.minAmount === '0' || values.minAmount === 0) {             
        errors.minAmount = 'Please enter an amount greater than zero.';         
    }
    if (REQUIRED(values.maxAmount)) {
        errors.maxAmount = 'Please enter max amount.';
    }
    if (!errors.minAmount && !errors.maxAmount && Number(values.maxAmount) <= Number(values.minAmount)) {
        errors.maxAmount = 'Max amount should be greater than min amount.';
    }

    if (values.callBackUrl && URL(values.callBackUrl)) {
        errors.callBackUrl = 'Please enter valid callBack Url.';
    }

    if (REQUIRED(values.validityPeriod)) {
        errors.validityPeriod = 'Please select validity.';
    }

        const userDefineFields = values.userDefineFields || [];
        console.log("userDefine values:", userDefineFields);

        const userDefineFieldsError = [];

        userDefineFields.forEach((field, index) => {
            const fieldError = {};

            const hasName = !!field.name;
            const hasType = !!field.type;
            const hasValidators = !!field.validators;

            // If only "name" exists, "type" and "validators" are required
            if (hasName && (!hasType && !hasValidators)) {
                fieldError.type = "Field Type is required when name is provided.";
                fieldError.validators = "User Input are required when name is provided.";
            }
            if (field.name && field.name.length > 50) {
                fieldError.name = 'Cannot be more than 50 characters.';
            }
            
            // If "type" exists but not the other two
            else if (hasType && (!hasName || !hasValidators)) {
                if (!hasName) fieldError.name = "Name is required when type is provided.";
                if (!hasValidators) fieldError.validators = "User Input  are required when type is provided.";
            }
            // If "validators" exists but not the other two
            else if (hasValidators && (!hasName || !hasType)) {
                if (!hasName) fieldError.name = "Name is required when validators are provided.";
                if (!hasType) fieldError.type = " Field Type is required when validators are provided.";
            }

            // If there are errors, store them in the error array
            if (Object.keys(fieldError).length > 0) {
                userDefineFieldsError[index] = fieldError;
            }
        });

        // If there are any errors, add them to the errors object
        if (userDefineFieldsError.length > 0) {
            errors.userDefineFields = userDefineFieldsError;
        }

        return errors;

};

export default validate;
